import { jsxs as f, jsx as n } from "react/jsx-runtime";
import s from "classnames";
import { usePagination as g } from "../usePagination.js";
import { DOTS as b } from "../pagintaionHeplers.js";
import N from "../../../icons/ArrowLeftBold.js";
import h from "../../../icons/ArrowRightBold.js";
const w = "forma-ui__pagination__root", k = "forma-ui__pagination__item", v = "forma-ui__pagination__arrow", x = "forma-ui__pagination__disabled", P = "forma-ui__pagination__active", t = {
  root: w,
  item: k,
  arrow: v,
  disabled: x,
  active: P
}, z = ({ page: c, size: m = 10, count: l = 0, onChange: i }) => {
  const a = c ? Number(c) : 1, r = g({
    currentPage: a,
    totalCount: l,
    pageSize: m
  });
  if (!(l && r && r.length > 1))
    return null;
  const e = Number(r[r.length - 1]), d = () => {
    const o = a && a > 1 ? a - 1 : 1;
    i(o);
  }, u = () => {
    const o = a && a < e ? a + 1 : e;
    i(o);
  }, _ = (o) => {
    i(o);
  };
  return /* @__PURE__ */ f("div", { className: t.root, children: [
    /* @__PURE__ */ n("button", { className: s(t.arrow, a && a <= 1 && t.disabled), onClick: d, children: /* @__PURE__ */ n(N, { className: t.icon }) }),
    r && r.map((o, p) => o === b ? /* @__PURE__ */ n("span", { children: o }, o + p) : /* @__PURE__ */ n(
      "button",
      {
        className: s(t.item, a === o && t.active),
        onClick: () => _(Number(o)),
        children: o
      },
      o
    )),
    /* @__PURE__ */ n("button", { className: s(t.arrow, a && a >= e && t.disabled), onClick: u, children: /* @__PURE__ */ n(h, { className: t.icon }) })
  ] });
};
export {
  z as default
};
